import React from "react";
import MissionClientFees from "../../components/viewers/MissionClientFees";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";

type Props = StackScreenProps<RootStackParamList, "MissionClientFees">;

const MissionClientFeesScreen: React.FC<Props> = ({ route }) => {
    return route.params.fees && <MissionClientFees fees={route.params.fees} />;
};

export default MissionClientFeesScreen;
